import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

import { ImageGrid, ImageGridItem } from "../ImageGrid";

import styles from "./ProductSidebarImages.module.scss";

function ProductSidebarImages({
  images,
  imagesAreLoading,
  setImagesAreLoading,
  onAddImage,
  onRemoveImage,
  onSortEnd
}) {
  const SortableImageGridItem = SortableElement(
    ({ src, index, onSubtractItem }) => (
      <ImageGridItem
        src={src}
        circle
        index={index}
        onSubtractItem={onSubtractItem}
      />
    )
  );

  const SortableImageGrid = SortableContainer(({ onSubtractItem }) => (
    <ImageGrid
      onAddItem={onAddImage}
      loading={imagesAreLoading}
      setLoading={setImagesAreLoading}
    >
      {images.map((image, index) => (
        <SortableImageGridItem
          key={index}
          src={image.url}
          index={index}
          onSubtractItem={onSubtractItem}
        />
      ))}
    </ImageGrid>
  ));

  return (
    <div className={styles.imageGrid}>
      <span className="contentTitle">Product Images</span>
      {
        <span className={styles.formDescription}>
          Click on any photo's delete icon to remove the image. Click and hold
          to reorder your images.
        </span>
      }

      <SortableImageGrid
        distance={1}
        onSubtractItem={onRemoveImage}
        onSortEnd={onSortEnd}
        axis="xy"
      />
    </div>
  );
}

export default ProductSidebarImages;
